<template>
  <!-- Begin Page Content -->
  <div class="container">

    <div class="card my-4">
      <div class="card-header row m-0">
        <div class="col">
          <h4>Санал хүсэлт</h4>
          <p>Та санал хүсэлт болон систем хэрэглэх явцад тулгарсан асуудал, ойлгомжгүй зүйл байвал байвал 'Санал хүсэлт +' товч даран илгээнэ үү.</p>
        </div>
        <div class="col-auto">
          <button class="btn btn-danger btn-sm" @click="add">Санал хүсэлт +</button>
        </div>

      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
            v-if="alerts!=null && alerts.length>0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Гарчиг</th>
                <th>Дэлгэрэнгүй</th>
                <th>Төрөл</th>
                <th>Хариу</th>
                <th>Огноо</th>
                <!-- <th>Үйлдэл</th> -->
              </tr>
            </thead>

            <tbody>
              <tr v-for="(alert, index) in alerts" v-bind:key="alert.id">
                <td>{{index+1}}</td>
      
                <td>{{alert.name}}</td>
                <td>{{alert.description}}</td>
                <td>
                  {{alert.type}}
                </td>
                <td>
                  <div class="p-3" style="border:1px dashed #1cc88a;border-radius: 15px;" v-if="alert.reply && alert.reply!=''">
                    {{alert.reply}}
                  </div>
                </td>
                <td>
                  {{alert.createdAt | formatDate}}
                </td>
                <!-- <td>
                  <div class="row">
                    <button class="btn btn-info btn-sm mx-1" @click="edit(alert, index)">засах</button>
                    <button class="btn btn-danger btn-sm mx-1" @click="deleteAlert(alert, index)">устгах</button>
             
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
          <div v-else class="alert alert-info text-center">Мэдээлэл оруулаагүй байна.</div>
        </div>
        <!-- <button v-if="end==false" class="btn btn-block btn-success" @click="getItems()">Дараагийнх</button> -->
      </div>
    </div>


     <!-- Modal -->
    <div
      class="modal fade"
      id="alertModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="alertModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="alertModalLabel">Санал хүсэлт нэмэx</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Гарчиг</label>
                <input
                  v-model.trim="tmpAlert.name"
                  class="form-control"
                  placeholder="Гарчиг оруулна уу"
                />
              </div>
              <div class="form-group">
                <label for="exampleFormControlSelect1">Төрөл:</label>
                <select class="form-control" v-model="tmpAlert.type">
                  <option v-for="type in types" v-bind:value="type">{{type}}</option>
                </select>
              </div>


              <div class="form-group">
                <label>Дэлгэрэнгүй</label>
                <textarea
                  rows="5"
                  v-model.trim="tmpAlert.description"
                  class="form-control"
                  placeholder="Тайлбар мэдээлэлээ оруулна уу/Тулгарсан асуудал байвал дэлгэрэнгүй бичнэ үү./"
                />
              </div>
              
              
              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
            <button
              @click="saveAlert(tmpAlert)"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >Xадгалаx</button>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../firebaseConfig.js";
import moment from "moment";
export default {
  name: "GlobalAlerts",
  data() {
    return {
      alerts: [],
      end: false,
      lastVisible:null,
      firstVisible:null,
      loading:false,
      pageSize: 20,
      tmpAlert:{},
      editIndex:null,
      types:[
        "Шинэ шаардлага",
        "Алдаа",
        "Ойлгомжгүй байдал",
        "Бусад"
      ]


    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  created() {
    this.getItems();
  },
  methods: {
    async getItems(){
      if(this.end!=true){
        var querySnapshot;
        var first=false;
        if(this.lastVisible==null){
          querySnapshot=await fb.db.collection("GlobalAlerts")
          .where("userId", "==", this.$store.getters.currentUser.uid)
          // .orderBy("createdAt", "desc").limit(this.pageSize).get();
           .orderBy("createdAt", "desc").get();
          if(querySnapshot!=null && !querySnapshot.empty){
            this.firstVisible=querySnapshot.docs[0];
            first=true;
          }
        }
        else{
          querySnapshot=await fb.db.collection("GlobalAlerts")
          .where("userId", "==", this.$store.getters.currentUser.uid)
          .orderBy("createdAt", "desc").startAfter(this.lastVisible).limit(this.pageSize).get();
        }
        
        if(querySnapshot!=null && !querySnapshot.empty){
          if(first==true || ( this.first!=null && this.firstVisible.id!=null && this.firstVisible.id!=querySnapshot.docs[0].id)){
            for(const itemDoc of querySnapshot.docs){
              let item=itemDoc.data();
              item.id=itemDoc.id;
              this.alerts.push(item);
            }
            this.lastVisible=querySnapshot.docs[querySnapshot.docs.length-1];
          }
          else
            this.end=true;
          
        }
      }
    },

    add() {
      this.editIndex=null;
      this.tmpAlert = {};
      $("#alertModal").modal("toggle");
    },
    edit(alert, index) {
      this.tmpAlert = Object.assign({}, alert);
      this.editIndex=index;
      $("#alertModal").modal("toggle");
    },
    saveAlert(alert){
      if(alert!=null && alert!=undefined){

          if (alert!= null && alert != undefined && alert.name != "" && alert.description) {
            if(this.userProfile && this.userProfile.customer){
                alert.customer=this.userProfile.customer
            }
            if (alert.id != null && alert.id != "") {
              
              fb.db
                .collection("GlobalAlerts")
                .doc(alert.id)
                .update(alert);
              if(this.editIndex!=null && this.editIndex!=undefined && this.alerts.length>this.editIndex){
                this.alerts[this.editIndex]=alert;
                 this.editIndex=null;
              }
            } 
            else {
              alert.createdAt = new Date();
              alert.userId = this.$store.getters.currentUser.uid;
              alert.user = fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              );
              fb.db
                .collection("GlobalAlerts")
                .doc()
                .set(alert);
              this.refresh();
            }
            this.tmpAlert = {
              name: null,
              description: null,
            };
          } 
          else {
            alert("Та гарчиг,дэлгэрэнгүй мэдээллээ оруулна уу");
          }
        }
      
    },
    refresh(){
      this.alerts=[];
      this.end= false;
      this.lastVisible=null;
      this.firstVisible=null;
      this.loading=false
      this.tmpAlert={};
      this.getItems();
    }
   
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date;

        date = val.toDate();
 
      return moment(date).fromNow();
    }
  }
};
</script>